import cn from 'clsx'
import { ImageBox } from 'shared-components'

import { type LargeImage as LargeImageType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './LargeImage.module.sass'


function LargeImage({ image }: LargeImageType) {
    return (
        <section className={cn(s.LargeImage, 'container')}>
            <ImageBox image={image} />
        </section>
    )
}

export default LargeImage
